import { validateDate } from "~/shared/lib/DateFormat/dateFormat";

export const getSaveDateOrCurrentDate = (date: any) => {
  if (validateDate(date)) return new Date(date);
  else return new Date();
};
